/**
 * Created by sswaminathan on 9/28/22
 * File: DualInputComponent
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

/**
 *   TODO: Brief what is this component/class do
 */
import { useContext, useEffect, useMemo, useState } from 'react'
import {
  APP_ID_AUTONOMOUS_DEM,
  APP_ID_PRISMA_ACCESS_EDITION,
} from '../../../../../common/constants/GlobalConstants'
import { APP_ID_TO_NAME } from '../../../../../common/constants/LabelConstants'
import AppContext from '../../../../../common/context/AppContext'
import {
  ALLOW_DISABLE_ADDONS, QUANTITY_READONLY_ADDONS, SUBSCRIPTION_ACTION_EDIT,
  URL_VALIDATIONS
} from '../../../constants/SubscriptionConstant'
import CheckBoxComponent from '../../../dataInput/CheckBoxComponent'
import TextBox from '../../../dataInput/TextBox'
import ValidationFetcher from '../../../validation/ValidationFetcher'
import CapacityCalculator from '../capacityCalculator/CapacityCalculator'

const DualInputComponent = (props) => {
  const { app_id, dualNetworkAddons, allocation, ...rest } = props
  const { licenseInfo } = rest
  const { getAppName } = useContext(AppContext)
  const { selectedTreeNode, instancesKeyBy } = rest
  const [checkBoxStatus, setCheckBoxStatus] = useState(true)
  const [allowDisable, setAllowDisable] = useState(false)

  const label = getAppName(dualNetworkAddons[app_id][0].app_id, APP_ID_TO_NAME[dualNetworkAddons[app_id][0].app_id])
  useEffect(() => {
    if (allocation) {
      setCheckBoxStatus(true)
    }
  }, [allocation])

  useEffect(() => {
    if (allocation || (!allocation && !ALLOW_DISABLE_ADDONS.has(app_id))) {
      setAllowDisable(false)
    }
    else if (!allocation && ALLOW_DISABLE_ADDONS.has(app_id)) {
      const paeInstance = licenseInfo[APP_ID_PRISMA_ACCESS_EDITION]
      if (!paeInstance || (paeInstance && paeInstance.entitlements?.find(each => each.app_id === app_id && !each.purchased_size > 0))) {
        // addon allow to disable
        setAllowDisable(true)
      }
      else {
        setAllowDisable(false)
      }
    }
  }, [allocation, instancesKeyBy, app_id, rest.instances, selectedTreeNode.id, licenseInfo])

  const disableTextBox = useMemo(() => {
    if (allocation || QUANTITY_READONLY_ADDONS.has(app_id)) {
      return true
    }
    if (rest.licenseAction === SUBSCRIPTION_ACTION_EDIT) {
      const productInfo = licenseInfo[APP_ID_PRISMA_ACCESS_EDITION]?.entitlements?.find(each => each.app_id === app_id)
      if (URL_VALIDATIONS.includes(productInfo?.app_id)) {
        return true
      }
      if (!allocation && ALLOW_DISABLE_ADDONS.has(productInfo?.app_id)) {
        return !checkBoxStatus
      }
    }
    if (!allocation && ALLOW_DISABLE_ADDONS.has(app_id)) {
      return !checkBoxStatus
    }
  }, [allocation, app_id, rest.licenseAction, licenseInfo, checkBoxStatus])


  const [validationAppOne, validationAppTwo] = useMemo(() => {
    const validationRules = []
    dualNetworkAddons[app_id]?.forEach(({ app_id, license_type, purchased_size }) => {
      const rules = ValidationFetcher(app_id, license_type, rest)
      rules.max_quantity = app_id !== APP_ID_AUTONOMOUS_DEM ? (rules.max_quantity ?? purchased_size) : rules.max_quantity
      validationRules.push(rules)
    })
    return validationRules
  }, [app_id, dualNetworkAddons, rest])

  return (<div className='tw-flex tw-flex-row tw-ml-2'>
    <div style={{ 'flex-basis': '42%' }}>
      <CheckBoxComponent
        {...{ app_id,
          allocation,
          allowDisable,
          setCheckBoxStatus,
          label,
          product: dualNetworkAddons[app_id][0],
          product_dual: dualNetworkAddons[app_id][1],
          ...rest }} />
    </div >
    <div style={{ 'flex-basis': '66%' }}>
      <div className='tw-flex tw-flex-row'>
        <div style={{ 'flex-basis': '25%' }}>
          <TextBox
            width='91px'
            height='32px'
            placeHolder=''
            defaultCapacity={CapacityCalculator(
              { product: dualNetworkAddons[app_id][0],
                dualNetwork: true,
                allocation,
                ...rest })}
            maxCapacity={dualNetworkAddons[app_id][0].purchased_size}
            name={dualNetworkAddons[app_id][0].formFieldName}
            cspAccount={dualNetworkAddons[app_id][0].support_account_id}
            validationRules={validationAppOne}
            appId={dualNetworkAddons[app_id][0].app_id}
            disabled={disableTextBox}
            checkBoxStatus={checkBoxStatus}
            checkBoxLabelDesc
            {... { ...rest, dualNetwork: true, product: dualNetworkAddons[app_id][0], allocation } }/>
        </div>
        <div className='tw-ml-11' style={{ 'flex-basis': '25%' }}>
          <TextBox
            width='91px'
            height='32px'
            placeHolder=''
            defaultCapacity={CapacityCalculator(
              {
                product: dualNetworkAddons[app_id][1],
                dualNetwork: true,
                allocation,
                ...rest })}
            maxCapacity={dualNetworkAddons[app_id][1].purchased_size}
            name={dualNetworkAddons[app_id][1].formFieldName}
            cspAccount={dualNetworkAddons[app_id][1].support_account_id}
            appId={dualNetworkAddons[app_id][1].app_id}
            validationRules={validationAppTwo}
            disabled={disableTextBox}
            checkBoxStatus={checkBoxStatus}
            checkBoxLabelDesc
            {... { ...rest, dualNetwork: true, product: dualNetworkAddons[app_id][1], allocation } }/>
        </div>
      </div>
    </div>
  </div>)
}

DualInputComponent.propTypes = {}
export default DualInputComponent
